<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12">
          <div class="flex flex-col md:flex-row justify-between items-center">
            <button
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto invisible hidden md:block">
              + Create New Category
            </button>
            <h1 class="font-semibold text-2xl lg:text-3xl text-center">
              Create Categories
            </h1>
            <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto hidden md:block"
                    @click="onClickCreateNew">
              + Create New Category
            </button>
          </div>
          <section class="text-center text-sm max-w-xl mx-auto mt-5">
            Use the tools below to add the categories that will be included in the form sent to each of your event
            attendees.. In the next section, you will
            add category specific items for your event attendees to select for each category.
          </section>
          <div class="mt-5 md:hidden">
            <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    @click="onClickCreateNew">
              + Create New Category
            </button>
          </div>
          <section class="mt-5">
            <table class="w-full">
              <thead class="md:border-b border-gray-300">
              <tr class="text-gray-500 text-sm">
                <th class="w-64">
                  <div class="flex items-center">
                    <label
                        class="w-20 inline-flex items-center px-3 py-1 border-2 border-gray-200 md:border-none rounded-lg">
                      <input v-model="allSelected" class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                             type="checkbox">
                      <v-popover :placement="'bottom-start'" class="ml-3">
                        <button class="btn">
                          <img alt="Order Details Categories Page" src="@/assets/icons/ic_chevron_down.svg"/>
                        </button>
                        <div slot="popover">
                          <div class="bg-white text-gray-700 py-3" role="menu">
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="allSelected = true">
                              Select All
                            </a>
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="allSelected = false">
                              Unselect All
                            </a>
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="onClickRemoveSelectedCategories">
                              Delete Selected
                            </a>
                          </div>
                        </div>
                      </v-popover>
                    </label>
                    <div class="font-semibold text-xs text-gray-600 text-left hidden md:block">CATEGORY</div>
                  </div>
                </th>
                <th class="hidden md:table-cell font-semibold text-xs text-gray-600 text-left">
                  DESCRIPTION
                </th>
                <th class="w-32 hidden md:table-cell font-medium">
                  <div class="flex items-center">
                    <div class="mr-2 font-semibold text-xs text-gray-600"># OF ITEMS</div>
                    <v-popover placement="bottom-start" trigger="hover">
                      <button class="btn" type="button">
                        <img alt="BuildaBox Order Process" src="@/assets/icons/ic_info.png"/>
                      </button>
                      <div slot="popover">
                        <div class="w-64 p-4">
                          Enter the number of items that an attendee may select from a category in their order
                        </div>
                      </div>
                    </v-popover>
                  </div>
                </th>
                <th class="w-24 hidden md:table-cell font-medium"></th>
              </tr>
              </thead>
              <tbody v-if="progressLoading">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5">
                    <Spinner class="mx-auto" orange/>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else-if="categories.length === 0">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5"></div>
                </td>
              </tr>
              </tbody>
              <draggable v-else v-model="categories" handle=".draggable-handler" tag="tbody" @update="onUpdateSort">
                <tr v-for="(category, index) in categories" :key="index">
                  <td class="py-5">
                    <div class="flex items-center">
                      <label class="md:w-20 inline-flex items-center px-3 py-1">
                        <input v-model="category.isSelected"
                               class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                               type="checkbox">
                        <button class="btn ml-3 draggable-handler">
                          <img alt="Order Details Categories Page" src="@/assets/icons/ic_drag.svg"/>
                        </button>
                      </label>
                      <div class="font-semibold flex-1">{{ category.name }}</div>
                      <div class="md:hidden">
                        <button class="btn p-3" @click="onClickEditCategory(category)">
                          <img alt="BuildaBox Order Details Categories Page" src="@/assets/icons/edit-pencil.svg"/>
                        </button>
                        <button class="btn p-3 ml-2" @click="onClickRemoveCategory(category)">
                          <img alt="BuildaBox Order Details Categories Page" src="@/assets/icons/ic_remove.svg"/>
                        </button>
                      </div>
                    </div>
                    <div class="md:hidden font-normal ml-12 mr-5">
                      <div class="mt-2 text-gray-600">{{ category.description }}</div>
                      <div class="mt-5">
                        <span class="text-gray-600">NUMBER OF ITEMS:</span>
                        <span class="ml-4">{{ category.items_quantity }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="py-5 hidden md:table-cell font-normal text-gray-600 text-left">
                    {{ category.description }}
                  </td>
                  <td class="py-5 hidden md:table-cell font-normal text-center">
                    {{ category.items_quantity }}
                  </td>
                  <td class="py-5 hidden md:table-cell">
                    <button class="btn p-3" @click="onClickEditCategory(category)">
                      <img alt="BuildaBox Order Details Categories Page" src="@/assets/icons/edit-pencil.svg"/>
                    </button>
                    <button class="btn p-3 ml-2" @click="onClickRemoveCategory(category)">
                      <img alt="BuildaBox Order Details Categories Page" src="@/assets/icons/ic_remove.svg"/>
                    </button>
                  </td>
                </tr>
              </draggable>
            </table>
          </section>
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    v-if="order.from === 'buildabox'"
                    class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mr-3"
                    @click="skip"
                >
                  <span>Skip</span>
                </button>
                <button
                    :disabled="!canProceedToNextStep"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                    @click="$emit('submit')"
                >
                  <span v-if="!progressSaving">Next</span>
                  <Spinner v-if="progressSaving" class="mx-auto"/>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Modal v-if="showModal">
      <div slot="modal-wrapper">
        <div class="flex justify-center p-2">
          <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-3xl">
            <OrderCategoryEditor
                :category="selectedCategory"
                :order-uuid="this.order.uuid"
                @cancel="showModal = false"
                @submit="showModal = false; loadCategories()"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import Spinner from '@/components/common/Spinner'
import draggable from 'vuedraggable'
import Api from '@/api/api_v1.0'
import OrderCategoryEditor from '@/components/OrderCategoryEditor'

export default {
  components: { OrderCategoryEditor, Spinner, Modal, draggable },
  data () {
    return {
      categories      : [],
      selectedCategory: '',
      showModal       : false,
      progressLoading : false,
      progressSaving  : false
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    allSelected: {
      get () {
        if (this.categories.length > 0) {
          return this.categories.findIndex(category => !category.isSelected) === -1
        } else {
          return false
        }
      },
      set (value) {
        this.categories.every(category => {
          category.isSelected = value
          return true
        })
      }
    },
    canProceedToNextStep () {
      return this.categories && this.categories.length > 0 || this.order.process == 3
    }
  },
  mounted () {
    this.loadCategories()
  },
  methods: {
    skip () {
      this.$emit('skip')
    },
    loadCategories () {
      this.progressLoading = true
      Api.getCategoriesForOrder(this.order.uuid).then(categories => {
        this.progressLoading = false
        this.categories = categories
      }).catch(() => {
        this.progressLoading = false
      })
    },
    onClickCreateNew () {
      const position = this.categories.length + 1
      this.selectedCategory = {
        uuid          : '',
        name          : '',
        description   : '',
        items_quantity: 1,
        file          : '',
        image         : '',
        position      : position
      }
      this.showModal = true
    },
    onClickEditCategory (category) {
      this.selectedCategory = JSON.parse(JSON.stringify(category))
      this.showModal = true
    },
    onSelectImage (event) {
      this.selectedCategory.file = event.target.files[0]
    },
    onClickRemoveCategory (category) {
      this.$swal({
        title            : 'Remove Category',
        text             : `Are you sure to remove the category - ${category.name}?`,
        confirmButtonText: 'Yes',
        cancelButtonText : 'No',
        showCancelButton : true
      }).then((result) => {
        if (result.isConfirmed) {
          category.isSelected = true
          this.removeCategories()
        }
      })
    },
    onClickRemoveSelectedCategories () {
      if (this.categories.findIndex(category => category.isSelected) !== -1) {
        this.$swal({
          title            : 'Remove Category',
          text             : `Are you sure to remove the selected categories?`,
          confirmButtonText: 'Yes',
          cancelButtonText : 'No',
          showCancelButton : true
        }).then((result) => {
          if (result.isConfirmed) {
            this.removeCategories()
          }
        })
      }
    },
    onUpdateSort () {
      const ids = this.categories.map(category => category.uuid)
      Api.sortCategoriesForOrder(this.order.uuid, ids)
    },
    async removeCategories () {
      const ids = this.categories.filter(category => category.isSelected).map(category => category.uuid)
      this.progressLoading = true
      Api.deleteCategoriesFromOrder(this.order.uuid, ids).then(() => {
        this.progressLoading = true
        this.loadCategories()
      }).catch(() => {
        this.progressLoading = false
      })
    }
  }
}
</script>